import { INameId } from '@modeso/types__aumico-lib-core-be';
import GISCSDefinitions from 'gics/definitions/20230318.js';

const SUBINDUSTRY_CODE_DIGITS_LENGTH = 6;

export class GICSCodesUtil {
    public static getAllGICSCodesAndSubindustryNames(): INameId[] {
        const giscsCodesAndNames = Object.keys(GISCSDefinitions)
            .filter((key) => key.length === SUBINDUSTRY_CODE_DIGITS_LENGTH)
            .map((key) => ({
                id: key,
                name: key + ' ' + GISCSDefinitions[key].name,
            })) as INameId[];

        giscsCodesAndNames.unshift({ id: '0', name: 'Not Specified' });

        return giscsCodesAndNames;
    }
}
